module.exports = __webpack_public_path__ + "img/home_enabled.ec27e61a.svg";